import script from "./promotionTrigger.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionTrigger.vue?vue&type=script&lang=ts&setup=true"

import "./promotionTrigger.vue?vue&type=style&index=0&id=a5627b9c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5627b9c"]])

export default __exports__